const createPayloadAction = type => payload => ({
  type,
  payload,
})

export default createPayloadAction
